<p-dialog
  [(visible)]="display"
  header="{{ 'label.AddToJobFair' | translate }}"
  (onHide)="onHide()"
  appendTo="body"
  modal="true"
  width="430"
>
  <div style="margin-bottom: 150px">
    <div>
      {{ 'label.RegistrationDate' | translate }}
      <p-datepicker [(ngModel)]="date" appendTo="body"></p-datepicker>
    </div>
    <br />
    <div>
      <p>{{ 'label.Event' | translate }}</p>
      <select
        [ngModel]="events && selectedEvent"
        (ngModelChange)="events && (selectedEvent = $event)"
        (change)="onEventChange()"
      >
        <option
          *ngFor="let event of events"
          [ngValue]="event?.value"
          [disabled]="isAlreadyRegistered(event)"
        >
          {{ event?.text }}
        </option>
      </select>
    </div>
    <br />
    <div>
      <p>{{ 'label.Package' | translate }}</p>
      <select
        [ngModel]="packages && selectedPackage"
        (ngModelChange)="packages && (selectedPackage = $event)"
      >
        <option *ngFor="let package of packages" [ngValue]="package?.value">
          {{ package?.text }}
        </option>
      </select>
    </div>
    <p style="color: red">{{ innerMsg }}</p>
  </div>
  <ng-template #footer>
    <p-button
      type="button"
      (click)="onSave()"
      label="{{ 'label.Save' | translate }}"
    ></p-button>
    <p-button
      type="button"
      (click)="onCancel()"
      label="{{ 'label.Cancel' | translate }}"
    ></p-button>
  </ng-template>
</p-dialog>
